import { useEffect } from 'react';
import { useGlobalUxStore, setCurrentPageNameSelector } from '@store';

export const useSetRoutName = (title) => {
  const { setCurrentPageName } = useGlobalUxStore(setCurrentPageNameSelector);
  useEffect(() => {
    setCurrentPageName(title);
  }, [title]);
};
